import { render, staticRenderFns } from "./volume-form.vue?vue&type=template&id=63c4d566"
import script from "./volume-form.vue?vue&type=script&lang=js"
export * from "./volume-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports